export default __webpack_public_path__ + "static/media/gallery_04.f57cea37.jpg";